var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0131836,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.7257C6.7375 15.5382 5.48438 14.8788 4.49063 13.7476C3.49688 12.6163 3 11.2882 3 9.76318C3 8.93818 3.1625 8.14756 3.4875 7.39131C3.8125 6.63506 4.275 5.97568 4.875 5.41318L5.94375 6.48193C5.46875 6.90693 5.10938 7.40068 4.86562 7.96318C4.62187 8.52568 4.5 9.12568 4.5 9.76318C4.5 10.8632 4.85 11.8351 5.55 12.6788C6.25 13.5226 7.15 14.0382 8.25 14.2257V15.7257ZM9.75 15.7257V14.2257C10.8375 14.0257 11.7344 13.5069 12.4406 12.6694C13.1469 11.8319 13.5 10.8632 13.5 9.76318C13.5 8.51318 13.0625 7.45068 12.1875 6.57568C11.3125 5.70068 10.25 5.26318 9 5.26318H8.94375L9.76875 6.08818L8.71875 7.13818L6.09375 4.51318L8.71875 1.88818L9.76875 2.93818L8.94375 3.76318H9C10.675 3.76318 12.0938 4.34443 13.2563 5.50693C14.4187 6.66943 15 8.08818 15 9.76318C15 11.2757 14.5031 12.5976 13.5094 13.7288C12.5156 14.8601 11.2625 15.5257 9.75 15.7257Z",
    fill: "white",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.e73eb6ad752b2167e393dcf1e3ef0fee.svg";
export { ForwardRef as ReactComponent };